import Embed from './embed';

class FacebookEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'facebook',
      customTitle: value.caption,
      iconName: '',
      iconClass: 'fa fa-facebook theme--light',
      buttons: ['edit'],
      denseMedia: true,
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static html({
    url,
  }) {
    const facebookEmbed = `
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=${url}&width=500&show_text=true&height=290&appId"
        width="500"
        height="290"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      />`;
    return `
      <div class="ql-text-wrapper">
        ${facebookEmbed}
      </div>
    `;
  }

  static value(domNode) {
    const { embedUrl } = domNode.dataset;
    return {
      url: embedUrl,
    };
  }
}

FacebookEmbed.blotName = 'facebookEmbed';
FacebookEmbed.className = 'ql-facebook';
FacebookEmbed.tagName = 'div';

export { FacebookEmbed as default };
